import React, { PureComponent } from 'react';
import MultiDatePicker from '../../components/DatePickers/MultiDatePicker';
import { Button, Loader } from 'kangarootime-ui';
import { connect } from 'react-redux';
import actions from './duck/actions';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';

class CopyMenuPopup extends PureComponent {
  constructor (props) {
    super(props);

    this.state = {
      isOpen: false,
      selectedDates: []
    };

    this.menuToCopy = {};
  }

  componentDidUpdate = (prevProps, prevState) => {
    if ((prevProps.copyingMenu && !this.props.copyingMenu) && this.state.isOpen) {
      this.setState({ isOpen: false, selectedDates: [] });
    }
  }

  selectDate = selectedDates => this.setState({ selectedDates });

  toggleDialog = () => this.setState({ isOpen: !this.state.isOpen });

  copyMenuToDates = () => {
    const { selectedDates } = this.state;

    this.props.copyMenu(this.menuToCopy, selectedDates);
  }

  render () {
    const { isOpen, selectedDates } = this.state;
    const { copyingMenu } = this.props;

    return (
      <Dialog open={isOpen} onClose={this.toggleDialog}>
        <DialogTitle>Copy this menu to the following dates</DialogTitle>
        <div style={{ margin: 8 }}>
          <MultiDatePicker
            disableToday={false}
            date={new Date()}
            onChange={this.selectDate}
          />
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
            <Loader loading={copyingMenu}>
              <Button type='primary' onClick={this.copyMenuToDates} disabled={selectedDates.length === 0}>
                Copy Menu
              </Button>
            </Loader>
          </div>
        </div>
      </Dialog>
    );
  }
}

function mapStateToProps (state) {
  return {
    copyingMenu: state.menus.info.copyingMenu
  };
}

function mapDispatchToProps (dispatch) {
  return {
    copyMenu: (menu, dates) => dispatch(actions.copyMenuRequest(menu, dates))
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(CopyMenuPopup);
